import { useNavigate } from 'react-router-dom';
import {
  UserCircle, IdCard, Wallet, ScrollText, CalendarOff, Briefcase,
  BellRing, Megaphone, ShieldCheck, FileText, ClipboardList, Star, CalendarCheck,
} from 'lucide-react';
import { LinkCard } from '@vnetwork/ui/primitives';

const NAV: { title: string; description: string; icon: typeof UserCircle; path: string }[] = [
  { title: 'Detailed Information', description: 'Your full personal profile', icon: UserCircle, path: '/account/info' },
  { title: 'My VCards', description: 'Manage your digital contact cards', icon: IdCard, path: '/account/vcards' },
  { title: 'Day-off Accounts', description: 'Your leave requests', icon: CalendarOff, path: '/account/dayoffs' },
  { title: 'Business Accounts', description: 'Your business-trip records', icon: Briefcase, path: '/account/businesses' },
  { title: 'On-call', description: 'Shifts, swaps and compensations', icon: BellRing, path: '/account/oncall' },
  { title: 'My Incomes', description: 'Commission and KPI income', icon: Wallet, path: '/account/my-incomes' },
  { title: 'Referral', description: 'Your referral link and referred customers', icon: Megaphone, path: '/account/referral' },
  { title: 'Accepted Policies', description: 'Regulations you have accepted', icon: ScrollText, path: '/account/regulations' },
  { title: 'Password & Security', description: 'Manage your password and security settings', icon: ShieldCheck, path: '/account/password-security' },
  { title: 'My Contracts', description: 'Your labor contracts and employment agreements', icon: FileText, path: '/account/contracts' },
  { title: 'Working Process', description: 'Your assigned working processes', icon: ClipboardList, path: '/account/working-process' },
  { title: 'My Ratings', description: 'Ratings you received and tickets to rate', icon: Star, path: '/account/my-ratings' },
  { title: 'Customer Events', description: 'Upcoming birthdays and founding-day events', icon: CalendarCheck, path: '/account/customer-events' },
];

/** Quick-navigation cards to the account sub-pages (mirrors the legacy Account Home nav). */
export function AccountNavCards() {
  const navigate = useNavigate();
  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
        gap: 'var(--vn-space-3)',
      }}
    >
      {NAV.map(({ title, description, icon: Icon, path }) => (
        <LinkCard
          key={path}
          href={path}
          title={title}
          description={description}
          icon={<Icon size={18} />}
          onClick={(e) => {
            e.preventDefault();
            navigate(path);
          }}
        />
      ))}
    </div>
  );
}
